const WA = "https://wa.me/917995495312?text=Hi%20Aria";

const MESSAGES = [
  { from: "aria", text: "Before we talk about your business — what problem in the world does it actually solve? Not what you sell. The real problem your customer loses sleep over." },
  { from: "user", text: "I run a small clinic in Hyderabad. We have around 80 patients a day." },
  { from: "aria", text: "Interesting. 80/day is a strong volume — which means you're almost certainly leaking ₹1L+ a month in no-shows and after-hours enquiries you don't even see. What's the one frustration that wakes you up?" },
  { from: "user", text: "Honestly… patients book and then don't turn up. We can't catch up." },
  { from: "aria", text: "Classic. At 30% no-show, on 80 patients × ₹800, that's ₹57K/month evaporating. The fix isn't reminders — it's predicting which patient won't show, the night before. Want me to show you exactly how?" },
];

const Demo = () => (
  <section id="demo" className="section bg-white" data-bg="white" data-testid="demo-section">
    <div className="section-inner">
      <div className="reveal" style={{ textAlign: "center", maxWidth: 700, margin: "0 auto" }}>
        <span className="eyebrow">Live Demo</span>
        <h2 className="section-h2" style={{ margin: "0 auto 18px" }}>
          Talk to <span className="serif">Aria.</span><br />
          Right now.
        </h2>
        <p className="section-sub" style={{ margin: "0 auto" }}>
          Not a recording. Aria responds with real intelligence — live,
          personalised, immediate.
        </p>
      </div>

      <div className="demo-wrap reveal">
        <div className="demo-window" data-testid="demo-window">
          <div className="demo-titlebar">
            <span className="demo-dot red" />
            <span className="demo-dot yellow" />
            <span className="demo-dot green" />
            <span className="demo-titlebar-name">
              <span className="live" /> aria.live
            </span>
          </div>
          <div className="demo-chat">
            {MESSAGES.map((m, i) => (
              <div key={i} className={`chat-msg ${m.from}`} data-testid={`chat-msg-${i}`}>
                {m.text}
              </div>
            ))}
          </div>
          <div className="demo-input">
            <input
              className="demo-input-field"
              placeholder="Type your business question…"
              disabled
              data-testid="demo-input"
            />
            <button className="demo-send" aria-label="Send" data-testid="demo-send">→</button>
          </div>
        </div>
      </div>

      <p className="demo-caption">
        No scripts. Every reply generated live by Aria.
      </p>
      <div className="demo-cta">
        <a href={WA} target="_blank" rel="noreferrer" className="btn btn-gold" data-testid="demo-wa-cta">
          Open in WhatsApp →
        </a>
      </div>
    </div>
  </section>
);

export default Demo;
